import { render, staticRenderFns } from "./DoubletType.vue?vue&type=template&id=02263908"
import script from "./DoubletType.vue?vue&type=script&lang=js"
export * from "./DoubletType.vue?vue&type=script&lang=js"
import style0 from "./DoubletType.vue?vue&type=style&index=0&id=02263908&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports